import moment from 'moment-timezone';

/**
 * Date utility functions for consistent date handling across the application
 */

/**
 * Get today's date in YYYY-MM-DD format using Indonesia timezone (UTC+7)
 * @returns Today's date as string in YYYY-MM-DD format
 */
export const getTodayDate = (): string => {
  // Use moment with Asia/Jakarta timezone to get correct local date
  return moment().tz('Asia/Jakarta').format('YYYY-MM-DD');
};

/**
 * Get a date in YYYY-MM-DD format
 * @param date - Date object or string
 * @returns Date as string in YYYY-MM-DD format
 */
export const formatDateToString = (date: Date | string): string => {
  if (typeof date === 'string') {
    return date;
  }
  return moment(date).tz('Asia/Jakarta').format('YYYY-MM-DD');
};

/**
 * Get start of day ISO string (00:00:00) in Indonesia timezone
 * @param dateStr - Date string in YYYY-MM-DD format
 * @returns ISO string for start of day
 */
export const getStartOfDay = (dateStr: string): string => {
  return moment.tz(dateStr, 'Asia/Jakarta').startOf('day').toISOString();
};

/**
 * Get end of day ISO string (23:59:59) in Indonesia timezone
 * @param dateStr - Date string in YYYY-MM-DD format
 * @returns ISO string for end of day
 */
export const getEndOfDay = (dateStr: string): string => {
  return moment.tz(dateStr, 'Asia/Jakarta').endOf('day').toISOString();
};
